import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  
  async createUserInProject({  commit }, payload) {
    return Vue.axios
      .post(Vue.$url("user-project"), payload)
      .then((rsp) => {
        Vue.$log.debug("created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Project', 1: payload.description }), {root : true});
      })
  },

  async fetchUserInProjects({ commit }) {
    return Vue.axios.get(Vue.$url("user-project"))
      .then((rsp) => { 
        commit('SET_USER_PROJECTS', rsp.data)
        return rsp.data;
      })
  },

  async updateUserInProject({ commit }, payload) {
    return Vue.axios
      .put(Vue.$url("user-project" + payload.id), payload)
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Project', 1: payload.description }), {root: true});
      });
  },

}